import React from 'react';
import { getResourcePath, trans } from '@spotahome/soyuz/client';

import PhotoScrollerList from '@common/components/PhoneScrollerList/PhotoScrollerList';
import Viewer360 from '@common/components/PhoneScrollerList/Viewer360';

const COMMON_IMAGE_PATH = '/images/phone-scroller';

const photoList = Array.from({ length: 10 }, (_, index) => {
  const photoName = `media-photo-${(index + 1).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  })}`;
  return {
    src: getResourcePath(
      `${COMMON_IMAGE_PATH}/media-photo/${photoName}-1x.jpg`
    ),
    srcSet: `${getResourcePath(
      `${COMMON_IMAGE_PATH}/media-photo/${photoName}-2x.jpg`
    )} 2x, ${getResourcePath(
      `${COMMON_IMAGE_PATH}/media-photo/${photoName}-3x.jpg`
    )} 3x`,
    description: photoName
  };
});

export const getStaticMediaList = () => [
  {
    title: trans('home.tenant.phone-scroller-section.video-tour.title'),
    content: trans('home.tenant.phone-scroller-section.video-tour.subtitle'),
    imageName: 'media-video'
  },
  {
    title: trans('home.tenant.phone-scroller-section.photos.title'),
    content: trans('home.tenant.phone-scroller-section.photos.subtitle'),
    imageName: 'media-photos'
  },
  {
    title: trans('home.tenant.phone-scroller-section.360.title'),
    content: trans('home.tenant.phone-scroller-section.360.subtitle'),
    imageName: 'media-360'
  },
  {
    title: trans('home.tenant.phone-scroller-section.floor-plan.title'),
    content: trans('home.tenant.phone-scroller-section.floor-plan.subtitle'),
    imageName: 'media-floorplan'
  }
];

export const getMediaList = () => [
  {
    title: trans('home.tenant.phone-scroller-section.video-tour.title'),
    titleText: trans('home.tenant.phone-scroller-section.video-tour.subtitle'),
    renderFrameContent: () => {
      return (
        <video autoPlay loop playsInline muted style={{ width: '100%' }}>
          <source
            src={getResourcePath('/videos/media-video-homecheckers.webm')}
          />
          <source
            src={getResourcePath('/videos/media-video-homecheckers.mp4')}
          />
        </video>
      );
    }
  },
  {
    title: trans('home.tenant.phone-scroller-section.photos.title'),
    titleText: trans('home.tenant.phone-scroller-section.photos.subtitle'),
    renderFrameContent: () => <PhotoScrollerList photoList={photoList} />
  },
  {
    title: trans('home.tenant.phone-scroller-section.360.title'),
    titleText: trans('home.tenant.phone-scroller-section.360.subtitle'),
    renderFrameContent: () => {
      const slideName = 'media-360';
      const srcString = `${COMMON_IMAGE_PATH}/${slideName}.jpg`;
      return (
        <div className="showcase-features__view-360">
          <Viewer360
            id="view360"
            src={getResourcePath(srcString)}
            config={{
              autoLoad: false,
              preview: getResourcePath(
                `/images/phone-scroller/media-360-preview.jpg`
              )
            }}
          />
        </div>
      );
    }
  },
  {
    title: trans('home.tenant.phone-scroller-section.floor-plan.title'),
    titleText: trans('home.tenant.phone-scroller-section.floor-plan.subtitle'),
    renderFrameContent: () => {
      const slideName = 'media-floorplan';
      const srcString = `${COMMON_IMAGE_PATH}/${slideName}-1x.jpg`;
      return <img src={getResourcePath(srcString)} alt={slideName} />;
    }
  }
];

export default { getStaticMediaList, getMediaList };
